module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABOElEQVRIS7WVvU0DQRCFv0cABATQAhJ1YHeABD2QOSVBxoifBIsOqAARUAE2TZAg0QIRSEho0Fh30rFefLvs3caz872dNzMrej4K85vZJnAI7GWyX4EHSZ/NezHAPXCUmbwOf5R00AZ4B24kXeVAzOwaGEnaagN8AKfAC3CSCJkCu8BU0noqwF9yBzwDtgK0DxwD7t2/ABuSvmIAM1sDvksBl1WSGMObZFwKSLEhv0SSblMy1zFmNsryIAYws21Jbv7S6QowkTTpBeDqgTdJO30BXPmZpKX14sCiEtXqAX/FvBq8ebNcpYCF+qA0Q0mzTruoKoWvDVc/aAKLXhAkcsAv9cUeBIBZqL5rwKBZ+849+Gt9rPTAzHwjnufsnoTYC0njxdCYmX8aw4RLOSHeaU/RqczJ0hb7A1zx5BnCkI4eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deviceWhite.png
// module id = 3JNZ
// module chunks = 0